<div class="alert-wrapper" *ngIf="informationWrapper.alertHeader">
  <app-info-text-box
    [title]="informationWrapper.alertHeader"
    [icon]="'assets/icons/info.svg'"
    [class]="'information--info information--psp-title'"
    [body]="{ english: informationWrapper.alertBody, native: informationWrapper.alertBody }"
    [isEnglishLanguage]="true"
  ></app-info-text-box>
</div>

<ng-content />

<div class="separator-line separator-line--centered"></div>

<div class="more-info" *ngIf="informationWrapper.infoHeader">
  <h2 class="more-info__heading">{{ informationWrapper.infoHeader }}</h2>
  <div class="more-info__item" *ngFor="let item of informationWrapper.infoItems">
    <h3 class="more-info__subtitle">{{ item.header }}</h3>
    <p class="more-info__body">{{ item.body }}</p>
  </div>
</div>
